import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class vStateRecordBase {

//#region stateId Prop
        @gridColumn({visible: true, columnIndex:0, allowSorting: true, headerKey: 'stateId', keyColumn: true})
        stateId : number;
//#endregion stateId Prop


//#region stateName Prop
        @gridColumn({visible: true, columnIndex:1, allowSorting: true, headerKey: 'stateName', keyColumn: false})
        stateName : string;
//#endregion stateName Prop


//#region countryId Prop
        @gridColumn({visible: true, columnIndex:2, allowSorting: true, headerKey: 'countryId', keyColumn: false})
        countryId : number;
//#endregion countryId Prop


//#region countryName Prop
        @gridColumn({visible: true, columnIndex:3, allowSorting: true, headerKey: 'countryName', keyColumn: false})
        countryName : string;
//#endregion countryName Prop


//#region createdBy Prop
        @gridColumn({visible: true, columnIndex:4, allowSorting: true, headerKey: 'createdBy', keyColumn: false})
        createdBy : number;
//#endregion createdBy Prop


//#region createdOn Prop
        @gridColumn({visible: true, columnIndex:5, allowSorting: true, headerKey: 'createdOn', keyColumn: false})
        createdOn : any;
//#endregion createdOn Prop


//#region statusId Prop
        @gridColumn({visible: true, columnIndex:4, allowSorting: true, headerKey: 'statusId', keyColumn: false})
        statusId : number;
//#endregion statusId Prop

}